import React, { useState } from "react";
import { StyleSheet, TouchableOpacity, View, Linking } from "react-native";
import Text from "@components/CustomText";
import OrderStatus from "@assets/svg/OrderStatus";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";
import { actions as returnOrderActions } from "@reducers/returnOrdersReducer";
import { useDispatch } from "react-redux";
import analytics from "@services/analytics";
import { RVP_EVENTS } from "@constants/analyticsEvents";
import { fontFamily } from "@utils/styles";
import PickupScheduleModal from "../pickupScheduleModal";
import CustomModal from "../CustomModal";
import { showLimitedImages } from "./OrderCard";

const ReturnOrderCard = (props) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showPickupSchedModal, setShowPickupSchedModal] = useState(false);
  const [selpickupDate, setSelPickupDate] = useState("");

  const dispatch = useDispatch();

  const { item = {}, navigateToDetails = () => {} } = props;
  const {
    order_id = "",
    parent_order = "",
    order_created_at,
    qty,
    short_name,
    agg_status_text,
    price_after_discount,
    payment_status,
    agg_status_icon,
    pickup_date_text,
    agg_status_color,
    enable_schedule,
    enable_cancel,
    set_schedule_date_text,
    cancel_btn_text,
    cant_cancel_text,
    user_name,
    user_phone,
    cx_formatted_address,
    cancel_confirmation_text,
    cancel_confirmation_heading,
    cancel_confirm_options,
    return_req_id,
    possible_pickup_days,
    resolved_status = {},
    sku_id,
    returnable,
    days_left,
    return_reason,
    request_type,
    return_qty,
    reject_reason,
    status,
    product_images = [],
    type,
    is_vacation_order,
  } = item;

  return (
    <>
      <CustomModal
        visible={showCancelModal}
        heading={cancel_confirmation_heading}
        message={cancel_confirmation_text}
        buttons={cancel_confirm_options}
        setShowModal={() => setShowCancelModal(false)}
        return_req_id={return_req_id}
        onPress={() => {
          dispatch(
            returnOrderActions.cancelReturnRequest({
              return_req_id,
              type,
            }),
          );
        }}
      />
      <PickupScheduleModal
        visible={showPickupSchedModal}
        onPress={() =>
          dispatch(
            returnOrderActions.pickupRVPScheduleReq({
              return_req_id,
              scheduled_date: selpickupDate,
            }),
          )
        }
        selpickupDate={selpickupDate}
        setSelPickupDate={(date) => setSelPickupDate(date)}
        pickupDays={
          possible_pickup_days
            ? possible_pickup_days.map((pickupDay) => ({
                text: pickupDay.date_text,
                key: pickupDay.date,
              }))
            : []
        }
        setShowModal={() => setShowPickupSchedModal(false)}
        return_req_id={return_req_id}
      />
      <TouchableOpacity
        testID=""
        style={styles.cardView}
        onPress={() =>
          navigateToDetails(parent_order, "RETURN", is_vacation_order)
        }
      >
        <View style={styles.topContainer}>
          <View>
            <Text style={styles.orderNumberText}>
              आर्डर नंबर -
              <Text style={styles.orderNumValText}>{` ${parent_order}`}</Text>
            </Text>
            <Text style={styles.itemText}>{`1 आइटम्स • ${qty} मात्रा`}</Text>
          </View>
          <View style={styles.orderDateContainer}>
            <Text style={styles.orderNumberText}>आर्डर की तारीख</Text>
            <Text
              style={styles.orderNumValText}
            >{` ${order_created_at.trim()}`}</Text>
          </View>
        </View>
        <View style={styles.imageView}>
          <View style={styles.imageContainer}>
            {product_images && showLimitedImages(product_images, 4)}
          </View>
          {/* {product_image && (
            <Image
              resizeMode="contain"
              source={{ uri: product_image }}
              style={styles.image}
            />
          )} */}
          <View style={{ width: normalize(200) }}>
            <Text style={styles.productName}>{short_name}</Text>
          </View>
        </View>
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <View>
            <Text style={styles.nameText}>{user_name}</Text>
            <TouchableOpacity
              testID="roc-whatsapp"
              onPress={() =>
                Linking.openURL(`whatsapp://send?phone=+91${user_phone}`)
              }
            >
              <View>
                <Text
                  style={{
                    color: colors.lightBlack,
                    fontSize: 12,
                    lineHeight: 16,
                    fontFamily: "NotoSansDevanagari-Regular",
                  }}
                >
                  +91 - {user_phone}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
          <View>
            <Text style={styles.namePriceText}>
              {price_after_discount > 0
                ? `₹${parseInt(price_after_discount, 10)}`
                : ""}
            </Text>
            <Text style={styles.paymentStatus}>
              {price_after_discount > 0 ? ` ${payment_status}` : ""}
            </Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            paddingTop: normalize(12),
            paddingBottom: normalize(4),
          }}
        >
          <OrderStatus
            orderStatus={agg_status_icon}
            style={{ marginRight: 6 }}
            orderStatusColor={agg_status_color}
          />
          <Text
            style={[
              styles.statusText,
              {
                color: agg_status_color,
              },
            ]}
          >
            {agg_status_text}{" "}
            {pickup_date_text && status !== "REJECTED"
              ? `| ${pickup_date_text}`
              : ""}
          </Text>
          {Boolean(reject_reason) && (
            <Text style={{ color: agg_status_color, marginBottom: 5 }}>
              - {reject_reason}
            </Text>
          )}
        </View>
        {cx_formatted_address && (
          <View style={{ width: "90%", flexDirection: "row" }}>
            <Text
              style={{
                lineHeight: 16,
                fontSize: 12,
                color: "rgba(0, 0, 0, 0.56)",
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {cx_formatted_address}
            </Text>
          </View>
        )}
        {resolved_status?.key ? (
          <Text
            style={[
              styles.resolvedStatus,
              { color: resolved_status?.color || colors.lightBlack },
            ]}
          >
            {resolved_status?.key} :
            <Text
              onPress={() => {
                if (resolved_status?.is_external_link) {
                  Linking.openURL(resolved_status?.value);
                }
              }}
            >
              {resolved_status?.value}
            </Text>
          </Text>
        ) : null}
        <View
          style={[
            styles.buttonView,
            {
              paddingTop:
                cant_cancel_text || enable_cancel || enable_schedule
                  ? normalize(20)
                  : 0,
            },
          ]}
        >
          {cant_cancel_text ? (
            <Text style={styles.cantCancelText}>{cant_cancel_text}</Text>
          ) : enable_cancel ? (
            <TouchableOpacity
              testID="roc-cancel"
              onPress={() => {
                setShowCancelModal(true);
                analytics.trackEvent(RVP_EVENTS.RETURN_CANCELLED, {
                  order_id,
                  return_req_id,
                  sku_id,
                  returnable,
                  days_left,
                  return_reason,
                  request_type,
                  return_qty,
                });
              }}
              style={[
                styles.cancelButton,
                {
                  marginRight: enable_schedule ? normalize(6) : 0,
                },
              ]}
            >
              <Text style={styles.cancelText}>{cancel_btn_text}</Text>
            </TouchableOpacity>
          ) : null}
          {enable_schedule && (
            <TouchableOpacity
              testID="roc-pickup-schedule"
              style={[
                styles.pickupButton,
                {
                  marginLeft: enable_cancel ? normalize(6) : 0,
                },
              ]}
              onPress={() => setShowPickupSchedModal(true)}
            >
              <Text style={styles.pickupText}>{set_schedule_date_text}</Text>
            </TouchableOpacity>
          )}
        </View>
      </TouchableOpacity>
    </>
  );
};

const styles = StyleSheet.create({
  cardView: {
    flexDirection: "column",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginVertical: 5,
    backgroundColor: colors.white,
  },
  orderDateContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  topContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  namePriceText: {
    fontSize: normalize(16),
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.mediumBlack,
  },
  orderNumberText: {
    fontSize: normalize(14),
    color: colors.lightBlack,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  orderNumValText: {
    fontWeight: "bold",
    color: colors.black,
    fontSize: normalize(14),
  },
  itemText: {
    fontSize: normalize(12),
    color: colors.lightBlack,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  imageView: {
    flexDirection: "row",
    paddingTop: normalize(12),
    paddingBottom: normalize(17),
    alignItems: "center",
  },
  productName: {
    color: colors.mediumBlack,
    fontSize: normalize(14),
    fontFamily: "NotoSansDevanagari-Regular",
  },
  statusText: {
    fontWeight: "bold",
    fontSize: 16,
    fontFamily: "Mukta",
  },
  paymentStatus: {
    color: colors.lightBlack,
    fontSize: 12,
    lineHeight: 16,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  cancelButton: {
    borderWidth: 1,
    borderColor: colors.borderBox,
    borderRadius: normalize(6),
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    height: 42,
  },
  pickupButton: {
    backgroundColor: colors.primary,
    borderRadius: normalize(6),
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    height: 42,
  },
  cancelText: {
    fontSize: normalize(14),
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  pickupText: {
    fontSize: normalize(14),
    fontFamily: "NotoSansDevanagari-SemiBold",
    color: colors.white,
  },
  buttonView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignSelf: "center",
    paddingTop: normalize(20),
  },
  nameText: {
    fontSize: normalize(16),
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.mediumBlack,
  },
  resolvedStatus: {
    fontSize: normalize(12),
    fontFamily: "Mulish-Regular",
    color: colors.lightBlack,
  },
  imageContainer: {
    overflow: "visible",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  cantCancelText: {
    flex: 1,
    fontFamily: fontFamily.semiBold,
    color: colors.lightBlack,
  },
});

export default ReturnOrderCard;
